"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class AccountsService {
    /**
     * @returns PeopleResponse Ensures a person exists for the logged in user
     * @throws ApiError
     */
    static ensurePersonExists() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/accounts/user/ensure_person_exists',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
}
exports.AccountsService = AccountsService;
